import React from "react";

// Boundary globale: cattura errori runtime (incl. ChunkLoadError dopo un redeploy)
// e mostra una schermata di recupero invece della pagina d'errore grezza.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    const msg = (error && error.message) || "";
    const isChunk = /ChunkLoadError|Loading chunk|dynamically imported module|Failed to fetch dynamically/i.test(msg);
    if (isChunk && !sessionStorage.getItem("fuma_chunk_reload")) {
      sessionStorage.setItem("fuma_chunk_reload", "1");
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="app-error-boundary" className="min-h-screen flex flex-col items-center justify-center gap-5 bg-[#0A0A0C] text-white px-6 text-center">
          <div className="font-display font-black text-2xl text-[#00E676]">Ops, qualcosa è andato storto</div>
          <p className="text-zinc-400 max-w-sm text-sm">Si è verificato un problema temporaneo. Ricarica la pagina per continuare a esplorare Fuma c'anduma.</p>
          <button
            data-testid="app-error-reload"
            onClick={() => { sessionStorage.removeItem("fuma_chunk_reload"); window.location.reload(); }}
            className="rounded-full bg-[#00E676] text-black font-semibold px-6 py-3 hover:brightness-110 transition-[filter]"
          >
            Ricarica
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
